// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hierarchy-chart-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.hierarchy-chart-search {
  flex: 1 1 26rem;
}

.hierarchy-chart-viewport {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 42rem;
  border-radius: 0.85rem;
  background:
    radial-gradient(circle at 20% 20%, rgba(0, 127, 92, 0.08), transparent 22%),
    radial-gradient(circle at 80% 20%, rgba(24, 129, 191, 0.08), transparent 22%),
    linear-gradient(180deg, #ffffff 0%, #fcfcfb 100%);
  border: 0.0625rem solid rgba(0, 0, 0, 0.08);
  cursor: grab;
}

.hierarchy-chart-viewport:active {
  cursor: grabbing;
}

.hierarchy-chart-actions {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 3;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.35rem;
  max-width: calc(100% - 1.5rem);
}

.hierarchy-chart-zoom-pill {
  display: inline-flex;
  align-self: flex-end;
  overflow: hidden;
  border-radius: 999px;
  box-shadow: 0 0.2rem 0.45rem rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.9);
  border: 0.0625rem solid rgba(51, 63, 76, 0.18);
}

.hierarchy-chart-action-button {
  padding: 0.2rem 0.5rem;
  font-size: 0.78rem;
  line-height: 1;
  border-radius: 999px;
  white-space: nowrap;
  box-shadow: 0 0.2rem 0.45rem rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.9);
}

.hierarchy-chart-action-button.btn-outline-secondary {
  border-color: rgba(51, 63, 76, 0.18);
}

.hierarchy-chart-action-button:hover {
  background: #fff;
}

.hierarchy-chart-zoom-button {
  border-radius: 0;
  box-shadow: none;
  border: 0;
  min-width: 2rem;
}

.hierarchy-chart-zoom-button + .hierarchy-chart-zoom-button {
  border-left: 0.0625rem solid rgba(51, 63, 76, 0.18) !important;
}

.hierarchy-chart-canvas {
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 0 0;
  padding: 2rem 1rem 3rem;
  min-width: 100%;
  min-height: 100%;
  z-index: 1;
}

.hierarchy-chart-tree {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.2rem;
  --org-card-width: 18rem;
  --org-card-gap: 2rem;
  --org-connector-length: 1.5rem;
}

.hierarchy-chart-tree.has-multiple-roots {
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  width: max-content;
  min-width: 100%;
}

.hierarchy-chart-node {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: calc(
    (var(--org-node-span) * var(--org-card-width)) +
    ((var(--org-node-span) - 1) * var(--org-card-gap))
  );
}

.hierarchy-chart-node.has-children::before {
  content: "";
  position: absolute;
  top: calc(var(--org-connector-length) * -1);
  left: 50%;
  width: 0.125rem;
  height: var(--org-connector-length);
  background: var(--gray);
  transform: translateX(-50%);
}

.hierarchy-chart-card {
  position: relative;
  min-width: calc(var(--org-card-width) - 1.5rem);
  max-width: 23rem;
  border-radius: 0.8rem;
  box-shadow: 0 0 0.85rem rgba(0, 0, 0, 0.08);
  background: #fffef6;
  border: 0.0625rem solid rgba(0, 0, 0, 0.06);
}

.hierarchy-chart-card.is-search-match {
  z-index: 2;
  border-color: #0a8c66 !important;
  border-width: 0.25rem !important;
  border-style: solid !important;
  outline: 0.1875rem solid rgba(10, 140, 102, 0.28);
  outline-offset: 0.125rem;
  box-shadow:
    0 0 0 0.35rem rgba(10, 140, 102, 0.26),
    0 0 1.9rem rgba(10, 140, 102, 0.46);
  background: linear-gradient(180deg, #ffffff 0%, #d8f6ea 100%);
  transform: translateY(-0.0625rem);
}

.hierarchy-chart-card.is-search-match .hierarchy-chart-name {
  color: var(--primary-color);
}

.hierarchy-chart-card.is-search-match .badge {
  box-shadow: 0 0.1rem 0.35rem rgba(0, 127, 92, 0.14);
}

.hierarchy-chart-card.is-search-match .card-body {
  background-color: transparent;
}

.hierarchy-chart-node.has-children.is-expanded > .hierarchy-chart-card::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: calc(var(--org-connector-length) * -1);
  width: 0.125rem;
  height: var(--org-connector-length);
  background: var(--gray);
  transform: translateX(-50%);
}

.hierarchy-chart-card-body {
  padding: 0.8rem 0.85rem 0.65rem;
}

.hierarchy-chart-card-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
}

.hierarchy-chart-title-block {
  flex: 1 1;
  min-width: 0;
  text-align: center;
}

.hierarchy-chart-name {
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--secondary-color);
  line-height: 1.25;
  word-break: break-word;
}

.hierarchy-chart-toggle,
.hierarchy-chart-details {
  border: 0;
  background: transparent;
  color: var(--secondary-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  line-height: 1;
}

.hierarchy-chart-card-actions .hierarchy-chart-toggle,
.hierarchy-chart-card-actions .hierarchy-chart-details {
  width: 1.6rem;
  height: 1.6rem;
  flex: 0 0 1.6rem;
}

.hierarchy-chart-card-actions .hierarchy-chart-toggle svg,
.hierarchy-chart-card-actions .hierarchy-chart-details svg {
  width: 0.85rem;
  height: 0.85rem;
}

.hierarchy-chart-toggle:hover,
.hierarchy-chart-details:hover {
  color: var(--primary-color);
}

.hierarchy-chart-card-footer {
  display: flex;
  justify-content: center;
  margin-top: 0.3rem;
}

.hierarchy-chart-children-badge {
  min-width: 5.25rem;
  text-align: center;
  padding: 0.2rem 0.75rem;
  line-height: 1;
}

.hierarchy-chart-card-actions {
  display: flex;
  justify-content: center;
  gap: 0.35rem;
  margin-top: 0.2rem;
}

.hierarchy-chart-children {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: var(--org-card-gap);
  padding-top: calc(var(--org-connector-length) + 0.45rem);
  width: calc(
    (var(--org-child-span-total) * var(--org-card-width)) +
    ((var(--org-child-span-total) - 1) * var(--org-card-gap))
  );
  margin: 0 auto;
}

.hierarchy-chart-children::before {
  content: "";
  position: absolute;
  top: 0.45rem;
  left: calc(
    ((var(--org-first-child-span) * var(--org-card-width)) +
    ((var(--org-first-child-span) - 1) * var(--org-card-gap))) / 2
  );
  right: calc(
    ((var(--org-last-child-span) * var(--org-card-width)) +
    ((var(--org-last-child-span) - 1) * var(--org-card-gap))) / 2
  );
  height: 0.125rem;
  background: var(--gray);
}

.hierarchy-chart-children .hierarchy-chart-node {
  flex: 0 0 auto;
}

.hierarchy-chart-children .hierarchy-chart-node::before {
  content: "";
  position: absolute;
  top: calc(var(--org-connector-length) * -1);
  left: 50%;
  width: 0.125rem;
  height: var(--org-connector-length);
  background: var(--gray);
  transform: translateX(-50%);
}

@media screen and (max-width: 991px) {
  .hierarchy-chart-viewport {
    min-height: 32rem;
  }

  .hierarchy-chart-tree {
    --org-card-width: 15rem;
  }

  .hierarchy-chart-card {
    min-width: calc(var(--org-card-width) - 1.5rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HierarchyChartView/HierarchyChartView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB;;;qDAGmD;EACnD,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;EAChD,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT;;;GAGC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,iDAAiD;EACjD,wBAAwB;EACxB;;uCAEqC;EACrC,6DAA6D;EAC7D,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,8CAA8C;EAC9C,eAAe;EACf,mCAAmC;EACnC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,wDAAwD;EACxD;;;GAGC;EACD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ;;;GAGC;EACD;;;GAGC;EACD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,+CAA+C;EACjD;AACF","sourcesContent":[".hierarchy-chart-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.hierarchy-chart-search {\r\n  flex: 1 1 26rem;\r\n}\r\n\r\n.hierarchy-chart-viewport {\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  min-height: 42rem;\r\n  border-radius: 0.85rem;\r\n  background:\r\n    radial-gradient(circle at 20% 20%, rgba(0, 127, 92, 0.08), transparent 22%),\r\n    radial-gradient(circle at 80% 20%, rgba(24, 129, 191, 0.08), transparent 22%),\r\n    linear-gradient(180deg, #ffffff 0%, #fcfcfb 100%);\r\n  border: 0.0625rem solid rgba(0, 0, 0, 0.08);\r\n  cursor: grab;\r\n}\r\n\r\n.hierarchy-chart-viewport:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.hierarchy-chart-actions {\r\n  position: absolute;\r\n  top: 0.75rem;\r\n  right: 0.75rem;\r\n  z-index: 3;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-end;\r\n  gap: 0.35rem;\r\n  max-width: calc(100% - 1.5rem);\r\n}\r\n\r\n.hierarchy-chart-zoom-pill {\r\n  display: inline-flex;\r\n  align-self: flex-end;\r\n  overflow: hidden;\r\n  border-radius: 999px;\r\n  box-shadow: 0 0.2rem 0.45rem rgba(0, 0, 0, 0.08);\r\n  background: rgba(255, 255, 255, 0.9);\r\n  border: 0.0625rem solid rgba(51, 63, 76, 0.18);\r\n}\r\n\r\n.hierarchy-chart-action-button {\r\n  padding: 0.2rem 0.5rem;\r\n  font-size: 0.78rem;\r\n  line-height: 1;\r\n  border-radius: 999px;\r\n  white-space: nowrap;\r\n  box-shadow: 0 0.2rem 0.45rem rgba(0, 0, 0, 0.08);\r\n  background: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.hierarchy-chart-action-button.btn-outline-secondary {\r\n  border-color: rgba(51, 63, 76, 0.18);\r\n}\r\n\r\n.hierarchy-chart-action-button:hover {\r\n  background: #fff;\r\n}\r\n\r\n.hierarchy-chart-zoom-button {\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  border: 0;\r\n  min-width: 2rem;\r\n}\r\n\r\n.hierarchy-chart-zoom-button + .hierarchy-chart-zoom-button {\r\n  border-left: 0.0625rem solid rgba(51, 63, 76, 0.18) !important;\r\n}\r\n\r\n.hierarchy-chart-canvas {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  transform-origin: 0 0;\r\n  padding: 2rem 1rem 3rem;\r\n  min-width: 100%;\r\n  min-height: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n.hierarchy-chart-tree {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2.2rem;\r\n  --org-card-width: 18rem;\r\n  --org-card-gap: 2rem;\r\n  --org-connector-length: 1.5rem;\r\n}\r\n\r\n.hierarchy-chart-tree.has-multiple-roots {\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  width: max-content;\r\n  min-width: 100%;\r\n}\r\n\r\n.hierarchy-chart-node {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  width: calc(\r\n    (var(--org-node-span) * var(--org-card-width)) +\r\n    ((var(--org-node-span) - 1) * var(--org-card-gap))\r\n  );\r\n}\r\n\r\n.hierarchy-chart-node.has-children::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: calc(var(--org-connector-length) * -1);\r\n  left: 50%;\r\n  width: 0.125rem;\r\n  height: var(--org-connector-length);\r\n  background: var(--gray);\r\n  transform: translateX(-50%);\r\n}\r\n\r\n.hierarchy-chart-card {\r\n  position: relative;\r\n  min-width: calc(var(--org-card-width) - 1.5rem);\r\n  max-width: 23rem;\r\n  border-radius: 0.8rem;\r\n  box-shadow: 0 0 0.85rem rgba(0, 0, 0, 0.08);\r\n  background: #fffef6;\r\n  border: 0.0625rem solid rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.hierarchy-chart-card.is-search-match {\r\n  z-index: 2;\r\n  border-color: #0a8c66 !important;\r\n  border-width: 0.25rem !important;\r\n  border-style: solid !important;\r\n  outline: 0.1875rem solid rgba(10, 140, 102, 0.28);\r\n  outline-offset: 0.125rem;\r\n  box-shadow:\r\n    0 0 0 0.35rem rgba(10, 140, 102, 0.26),\r\n    0 0 1.9rem rgba(10, 140, 102, 0.46);\r\n  background: linear-gradient(180deg, #ffffff 0%, #d8f6ea 100%);\r\n  transform: translateY(-0.0625rem);\r\n}\r\n\r\n.hierarchy-chart-card.is-search-match .hierarchy-chart-name {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.hierarchy-chart-card.is-search-match .badge {\r\n  box-shadow: 0 0.1rem 0.35rem rgba(0, 127, 92, 0.14);\r\n}\r\n\r\n.hierarchy-chart-card.is-search-match .card-body {\r\n  background-color: transparent;\r\n}\r\n\r\n.hierarchy-chart-node.has-children.is-expanded > .hierarchy-chart-card::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: calc(var(--org-connector-length) * -1);\r\n  width: 0.125rem;\r\n  height: var(--org-connector-length);\r\n  background: var(--gray);\r\n  transform: translateX(-50%);\r\n}\r\n\r\n.hierarchy-chart-card-body {\r\n  padding: 0.8rem 0.85rem 0.65rem;\r\n}\r\n\r\n.hierarchy-chart-card-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0;\r\n}\r\n\r\n.hierarchy-chart-title-block {\r\n  flex: 1;\r\n  min-width: 0;\r\n  text-align: center;\r\n}\r\n\r\n.hierarchy-chart-name {\r\n  font-size: 0.98rem;\r\n  font-weight: 700;\r\n  color: var(--secondary-color);\r\n  line-height: 1.25;\r\n  word-break: break-word;\r\n}\r\n\r\n.hierarchy-chart-toggle,\r\n.hierarchy-chart-details {\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--secondary-color);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  flex: 0 0 2rem;\r\n  line-height: 1;\r\n}\r\n\r\n.hierarchy-chart-card-actions .hierarchy-chart-toggle,\r\n.hierarchy-chart-card-actions .hierarchy-chart-details {\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n  flex: 0 0 1.6rem;\r\n}\r\n\r\n.hierarchy-chart-card-actions .hierarchy-chart-toggle svg,\r\n.hierarchy-chart-card-actions .hierarchy-chart-details svg {\r\n  width: 0.85rem;\r\n  height: 0.85rem;\r\n}\r\n\r\n.hierarchy-chart-toggle:hover,\r\n.hierarchy-chart-details:hover {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.hierarchy-chart-card-footer {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 0.3rem;\r\n}\r\n\r\n.hierarchy-chart-children-badge {\r\n  min-width: 5.25rem;\r\n  text-align: center;\r\n  padding: 0.2rem 0.75rem;\r\n  line-height: 1;\r\n}\r\n\r\n.hierarchy-chart-card-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 0.35rem;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.hierarchy-chart-children {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  flex-wrap: nowrap;\r\n  gap: var(--org-card-gap);\r\n  padding-top: calc(var(--org-connector-length) + 0.45rem);\r\n  width: calc(\r\n    (var(--org-child-span-total) * var(--org-card-width)) +\r\n    ((var(--org-child-span-total) - 1) * var(--org-card-gap))\r\n  );\r\n  margin: 0 auto;\r\n}\r\n\r\n.hierarchy-chart-children::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0.45rem;\r\n  left: calc(\r\n    ((var(--org-first-child-span) * var(--org-card-width)) +\r\n    ((var(--org-first-child-span) - 1) * var(--org-card-gap))) / 2\r\n  );\r\n  right: calc(\r\n    ((var(--org-last-child-span) * var(--org-card-width)) +\r\n    ((var(--org-last-child-span) - 1) * var(--org-card-gap))) / 2\r\n  );\r\n  height: 0.125rem;\r\n  background: var(--gray);\r\n}\r\n\r\n.hierarchy-chart-children .hierarchy-chart-node {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.hierarchy-chart-children .hierarchy-chart-node::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: calc(var(--org-connector-length) * -1);\r\n  left: 50%;\r\n  width: 0.125rem;\r\n  height: var(--org-connector-length);\r\n  background: var(--gray);\r\n  transform: translateX(-50%);\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .hierarchy-chart-viewport {\r\n    min-height: 32rem;\r\n  }\r\n\r\n  .hierarchy-chart-tree {\r\n    --org-card-width: 15rem;\r\n  }\r\n\r\n  .hierarchy-chart-card {\r\n    min-width: calc(var(--org-card-width) - 1.5rem);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
